// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowUUp16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-u-up': IconArrowUUp;
    }
}

/**
 * The icon component for the 'arrowUUp' icon
 */
export class IconArrowUUp extends IconSvg {
    public constructor() {
        super(arrowUUp16X16);
    }
}

registerIconSvg('icon-arrow-u-up', IconArrowUUp);
export const iconArrowUUpTag = 'nimble-icon-arrow-u-up';
